var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-style2-list" },
    _vm._l(_vm.defaultData, function (dataItm, dataIdx) {
      return _c(
        "div",
        {
          key: _vm.parentIndex + "_" + dataIdx,
          staticClass: "list-item list-item-flex",
          style: {
            padding:
              _vm.itemStyle.itemPaddingTop +
              "px " +
              _vm.itemStyle.itemPaddingLeft +
              "px",
          },
        },
        [
          _c("div", { staticClass: "flex-box" }, [
            _c("div", { staticClass: "list-item__title twolist-hidden" }, [
              _vm.itemStyle.show.includes("category") && dataItm.category
                ? _c(
                    "span",
                    {
                      staticClass: "list-item__category",
                      style: {
                        border: "1px solid " + _vm.itemStyle.categoryColor,
                        color: _vm.itemStyle.categoryColor,
                      },
                    },
                    [_vm._v(_vm._s(dataItm.category.name))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "list-title" }, [
                _vm._v(_vm._s(dataItm.title)),
              ]),
            ]),
            _vm._v(" "),
            _vm.itemStyle.show.includes("viewsNum")
              ? _c("div", { staticClass: "list-item__footer" }, [
                  _c("span", { staticClass: "list-views" }, [
                    _vm._v(_vm._s(dataItm.views_num) + "次浏览"),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }